define('plugin/package/view/PackageFilterView',['require','plugin/membership/view/MembershipFilterView','Config'],function (require) {

    var Parent = require('plugin/membership/view/MembershipFilterView');

    var Config = require('Config');

    /**
     * Package filter view
     *
     * @class PackageFilterView
     */
    return Parent.extend({

        namespace: 'package',

        _buildUrl: function () {
            var serviceItemViews = this.services.currentView.children;
            

            var services = [];
            var products = [];
            serviceItemViews.each(function (view) {
                if (view.isChecked()) {
                    services.push(view.model.get('id'));
                }
            });

            if (this.supportsProducts()) {
                var paidAttributeItemViews = this.products.currentView.children;
                paidAttributeItemViews.each(function (view) {
                    if (view.isChecked()) {
                        products.push(view.model.get('id'));
                    }
                });
            }

            if (this.supportsPaidAttributes()) {
                var paidAttributeItemViews = this.paidAttributes.currentView.children;
                paidAttributeItemViews.each(function (view) {
                    if (view.isChecked()) {
                        products.push(view.model.get('id'));
                    }
                });
            }

            var url = 'packages';
            if (services.length) {
                url += '/services/' + services.join(',');
            }
            if (products.length) {
                url += '/products/' + products.join(',');
            }

            return url;
        },

        supportsProducts: function () {
            return Config.getInstance().getPluginStatus('product'); 
        },

        supportsPaidAttributes: function () {
            return Config.getInstance().getPluginStatus('paid_attributes'); 
        }

    });

});
